import { Injectable, Injector } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ConfirmationDialogService } from '../../../ui/confirmation-dialog/index';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Router } from '@angular/router';
import { timer } from 'rxjs/internal/observable/timer';
import * as moment from 'moment';
import { AuthService } from './auth.service';
import { UserService } from './user.service';

@Injectable()
export class SessionService {

  confirmTimer;
  rootTimer;

  constructor (
    private injector: Injector,
    private authService: AuthService,
    private userService: UserService,
    private confirmationDialogService: ConfirmationDialogService,
    private i18n: I18n
  ) {}

  private startTimer(expiredAt: string) {

    const time = moment
      .duration(moment.utc(expiredAt).diff(moment.utc()))
      .subtract(environment.confirmTimeout, 'seconds')
      .asMilliseconds();

    this.rootTimer && this.rootTimer.unsubscribe();

    this.rootTimer = timer(time)
      .subscribe(() => {
        this.confirm();
      });
  }

  private confirm() {
    this.confirmTimer = timer(environment.confirmTimeout * 1000)
      .subscribe(() => {
        this.closeSession();
      });

    this.reInitTimer();
    this.confirmTimer.unsubscribe();
  }

  private reInitTimer() {
    this.authService.updateExtendAt().subscribe(({ expired_at: expiredAt }) => {
      this.startTimer(expiredAt);
    });
  }

  private closeSession() {
    const router = this.injector.get(Router);
    router.navigate([environment.loginUrl]);
  }

  init() {
    this.start();
    return this.authService.authorize();
  }

  start() {
    this.authService.authorize$.subscribe(() => {
      this.startTimer(this.userService.currentUserValue.session_expired_at);
    });

    this.authService.logout$.subscribe(() => {
      this.stop();
    });
  }

  stop() {
    this.confirmTimer && this.confirmTimer.unsubscribe();
    this.rootTimer && this.rootTimer.unsubscribe();
    this.confirmationDialogService.reset();
  }

}
